import { render } from "./sys-tabs.vue?vue&type=template&id=547289c4"
import script from "./sys-tabs.vue?vue&type=script&lang=js"
export * from "./sys-tabs.vue?vue&type=script&lang=js"

import "./sys-tabs.vue?vue&type=style&index=0&id=547289c4&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__